import isIP from 'validator/lib/isIP';
import isFQDN from 'validator/lib/isFQDN';
import { isValidPhoneNumber } from 'libphonenumber-js';

/* url validator */
export const urlValidator = (str) => {
  const protocols = ['http', 'https', 'ftp'];
  const hostWhitelist = [];
  const hostBlacklist = [];
  let requireTld = true;
  let requireProtocol = false;
  let allowUnderscore = false;

  if (
    str == null ||
    str.length == 0 ||
    str.length > 2083 ||
    str.startsWith('mailto:') 
  ) {
    return false;
  }
  /* declare variable */
  var protocol,
    user,
    auth,
    host,
    hostname,
    port,
    port_str,
    path,
    query,
    hash,
    split;
  /* check protocol */
  split = str.split('://');
  if (split.length > 1) {
    protocol = split.shift(split);
    if (protocols.indexOf(protocol) == -1) {
      return false;
    }
  } else if (requireProtocol == true) {
    return false;
  }
  str = split.join('://');
  /* check hash */
  split = str.split('#');
  str = split.shift(split);
  hash = split.join('#');
  if (hash != null && hash != "" && /(\s)/g.test(hash)) {
    return false;
  }
  /* check query params */
  split = str.split('?');
  str = split.shift(split);
  query = split.join('?');
  if (query != null & hash != "" && /(\s)/g.test(query)) {
    return false;
  }
  /* check path */
  split = str.split('/');
  str = split.shift(split);
  path = split.join('/');
  if (path != null & path != "" && /(\s)/g.test(path)) {
    return false;
  }
  /* check auth type urls */
  split = str.split('@');
  if (split.length > 1) {
    auth = split.shift(split);
    if (auth.indexOf(':') >= 0) {
      auth = auth.split(':');
      user = auth.shift(auth);
      if (!(/^(\S*$)/g.test(user))) {
        return false;
      }
      if (!(/^(\S*$)/g.test(user))) {
        return false;
      }
    }
  }
  /* check hostname */
  hostname = split.join('@');
  split = hostname.split(':');
  host = split.shift(split);
  if (split.length > 0) {
    port_str = split.join(':');
    try {
      port = parseInt(port_str, 10);
    } catch(err) {
      return false;
    }
    if (!(/^[0-9]+$/.test(port_str)) || port <= 0 || port > 65535) {
      return false;
    }
  }
  if (
    !isIP(host) && 
    !isFQDN(host, {
      require_tld: requireTld,
      allow_underscores: allowUnderscore,
      allow_trailing_dot: false,
      allow_numeric_tld: false,
    }) &&
    host != 'localhost'
  ) {
    return false;
  }
  if (Array.isArray(hostWhitelist) && !!(hostWhitelist.length) && !hostWhitelist.includes(host)) {
    return false;
  }
  if (Array.isArray(hostBlacklist) && !!(hostBlacklist.length) && hostBlacklist.includes(host)) {
    return false;
  }
  return true;
}

/* password validator */
/* /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/g */
export const passwordValidator = (val) => /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/g.test(val)

/* html validator */
export const htmlValidator = (val) => {
  if (val) {  
    try {
      const content = new DOMParser().parseFromString(val, "text/html")
      return content.body.textContent.length ? true : false
    } catch(err) {
      console.error(err);
      return false;
    }
  } else {  
    return false;
  }
}

/* email validator */
export const emailValidator = (val) => /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/gi.test(val);

/* phone validator */
export const phoneValidator = (val) => isValidPhoneNumber(val);

/* UNC validator */
export const uNCValidator = (val) => /^((\\\\([^\\:\|\[\]\/";<>+=,?* _]+)\\([\u0020-\u0021\u0023-\u0029\u002D-\u002E\u0030-\u0039\u0040-\u005A\u005E-\u007B\u007E-\u00FF]{1,80}))|[\w]\:)(((?:\\[\u0020-\u0021\u0023-\u0029\u002D-\u002E\u0030-\u0039\u0040-\u005A\u005E-\u007B\u007E-\u00FF]{1,255})+?|)(?:\\((?:[\u0020-\u0021\u0023-\u0029\u002B-\u002E\u0030-\u0039\u003B\u003D\u0040-\u005B\u005D-\u007B]{1,255}){1}(?:\:(?=[\u0001-\u002E\u0030-\u0039\u003B-\u005B\u005D-\u00FF]|\:)(?:([\u0001-\u002E\u0030-\u0039\u003B-\u005B\u005D-\u00FF]+(?!\:)|[\u0001-\u002E\u0030-\u0039\u003B-\u005B\u005D-\u00FF]*)(?:\:([\u0001-\u002E\u0030-\u0039\u003B-\u005B\u005D-\u00FF]+)|))|)))|)$/.test(val);